export const HOMEPAGE_EXCLUDED_PROVIDERS = ['EE', 'John Lewis Broadband', 'Plusnet Business']

export const EXCLUDED_PROVIDERS = [...HOMEPAGE_EXCLUDED_PROVIDERS, 'Three', 'Zen Internet', 'NOW TV', 'TVPlayer']

export const PROVIDERS = [
  {
    id: '12153',
    major: true,
    name: 'BT',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/bt.png',
    synopsis:
      'Get award-winning broadband plus calls from BT with optional digital TV — including BT Sport — available, too.\r\n\r\n**Compare BT broadband deals**\r\n\r\n',
    services: ['BROADBAND', 'TELEPHONE', 'TV'],
    connectionTypes: ['HOME', 'MOBILE']
  },
  {
    id: '12165',
    major: true,
    name: 'TalkTalk',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/talktalk.png',
    synopsis:
      'Award-winning TalkTalk offer broadband, TV and home phone package deals at competitive rates.\r\n\r\n**Compare TalkTalk broadband deals**',
    services: ['BROADBAND', 'TELEPHONE', 'TV'],
    connectionTypes: ['HOME']
  },
  {
    id: '12175',
    major: true,
    name: 'Sky',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/sky.png',
    synopsis:
      "Get superfast broadband, calls and award-winning TV content with Sky. All TV packages include Sky Q, Sky's revolutionary set-top box.\r\n\r\n**Compare Sky broadband deals**\r\n\r\n",
    services: ['BROADBAND', 'TELEPHONE', 'TV'],
    connectionTypes: ['HOME']
  },
  {
    id: '12179',
    major: true,
    name: 'Virgin Media',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/virgin-media.png',
    synopsis:
      "Virgin Media's superfast and ultrafast broadband packages combine great-value unlimited broadband with TV and phone bundle options up to 516Mb speeds. \r\n\r\n**Compare Virgin Media deals**",
    services: ['BROADBAND', 'TELEPHONE', 'TV'],
    connectionTypes: ['HOME', 'MOBILE']
  },
  {
    id: '12185',
    major: true,
    name: 'Plusnet',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/plusnet.png',
    synopsis:
      'Provider of the Year Plusnet offers high-value broadband and call packages with speeds of up to 76Mb.\r\n\r\n**Compare Plusnet broadband deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['HOME']
  },
  {
    id: '12189',
    major: false,
    name: 'Direct Save Telecom',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/direct-save-telecom.png',
    synopsis:
      "Direct Save Telecom offer a range of value phone and broadband packages, including short-term contracts.\r\n\r\n**Compare Direct Save Telecom's deals**",
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['HOME']
  },
  {
    id: '12191',
    major: false,
    name: 'Three',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/three.png',
    synopsis:
      "Get mobile broadband on the go with Three's USB dongle deals. Tap into 4G speeds wherever you are.\r\n\r\n**Compare Three deals**\r\n\r\n",
    services: ['BROADBAND'],
    connectionTypes: ['HOME', 'MOBILE']
  },
  {
    id: '12193',
    major: true,
    name: 'Vodafone',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/vodafone.png',
    synopsis:
      'Vodafone offers high-speed broadband deals for new and existing customers. A range of mobile broadband offers are also available.\r\n\r\n**Compare Vodafone deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['HOME', 'MOBILE']
  },
  {
    id: '12197',
    major: false,
    name: 'O2',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/o2.png',
    synopsis:
      'O2 mobile broadband offers super-fast 4G with products with a range of download allowances and devices from SIM cards to dongles to tablets.\r\n\r\n**Find O2 mobile broadband deals here!**',
    services: ['BROADBAND'],
    connectionTypes: ['MOBILE']
  },
  {
    id: '12203',
    major: false,
    name: 'Vonage',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/vonage.png',
    synopsis:
      'Vonage offers VoIP packages to suit every call need. Say goodbye to expensive long-distance and local calls. No line rental required.\r\n\r\n**Compare Vonage deals**',
    services: ['TELEPHONE'],
    connectionTypes: []
  },
  {
    id: '12212',
    major: false,
    name: 'TalkTalk Business',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/talktalk-business.png',
    synopsis:
      'TalkTalk Business is a business broadband provider offering speeds up to 76Mb and unlimited downloads. \r\n\r\n**Compare TalkTalk Business deals**\r\n',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12589',
    major: false,
    name: 'BT Business',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/bt-business.png',
    synopsis:
      "BT Business broadband offers a wide variety of broadband and call packages to suit any business's needs. \r\n\r\n**Compare BT Business deals**",
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12737',
    major: false,
    name: 'XLN Telecom',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/xln-telecom.png',
    synopsis:
      'Get fast, unlimited business broadband, cheap calls and award-winning service with XLN.\r\n\r\n**Compare XLN broadband deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12744',
    major: false,
    name: 'Tooway',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/tooway.png',
    synopsis:
      'Tooway offers fast, reliable Satellite Broadband to your home from just £24.95. Get broadband anywhere, even without a phone line!\r\n\r\n**Compare Tooway Satellite Broadband**\r\n',
    services: ['BROADBAND'],
    connectionTypes: []
  },
  {
    id: '12746',
    major: false,
    name: 'John Lewis Broadband',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/john-lewis-broadband.png',
    synopsis:
      'John Lewis offers phone and broadband deals with a range of speeds up to 76Mb.\r\n\r\n**Compare John Lewis deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['HOME']
  },
  {
    id: '12758',
    major: false,
    name: 'Virgin Media Business',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/virgin-media-business.png',
    synopsis:
      'Virgin Media’s super-fast business broadband packages combine excellent value unlimited broadband with inclusive calls for your business. \r\n\r\n**Compare Virgin Media Business deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12763',
    major: true,
    name: 'EE',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/ee.png',
    synopsis:
      'EE offers a selection of broadband, calls and TV packages at favourable rates. 4G mobile MiFis also available.\r\n\r\n**Compare EE broadband deals**',
    services: ['BROADBAND', 'TELEPHONE', 'TV'],
    connectionTypes: ['HOME', 'MOBILE']
  },
  {
    id: '12765',
    major: false,
    name: 'Plusnet Business',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/plusnet-business.png',
    synopsis:
      'Plusnet Business offers great value on business call and broadband packages, with up to 76Mb broadband speeds. \r\n\r\n**Compare Plusnet Business deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12773',
    major: false,
    name: 'OneBill Telecom',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/onebill-telecom.png',
    synopsis: '',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12774',
    major: false,
    name: 'Hyperoptic',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/hyperoptic.png',
    synopsis:
      'Hyperoptic offers outstanding speeds to select postcodes in the UK. Get up to 1Gb download speeds and a free wireless router.\r\n\r\n**Compare Hyperoptic deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['HOME']
  },
  {
    id: '12786',
    major: false,
    name: 'Gigaclear',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/gigaclear.png',
    synopsis:
      'Gigaclear designs, builds and operates a full fibre, ultrafast broadband network in rural areas across central and southern England. Established in 2010, its network now reaches homes and businesses in more than 450 communities across 22 counties – and growing.\r\n\r\n**Compare Gigaclear deals**',
    services: ['BROADBAND'],
    connectionTypes: ['HOME']
  },
  {
    id: '12791',
    major: false,
    name: 'Pop Telecom',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/pop-telecom.png',
    synopsis:
      'Pop Telecom offers ADSL broadband with speeds of up to 17Mb at low prices.\r\n\r\n**Compare Pop Telecom deals**',
    services: ['BROADBAND', 'TELEPHONE', 'TV'],
    connectionTypes: ['HOME']
  },
  {
    id: '12803',
    major: false,
    name: 'Origin',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/origin.png',
    synopsis:
      'Origin Broadband offers broadband and phone packages complete with truly unlimited usage, a free high-end router, and speeds of up to 66Mbps.\r\n\r\n**Compare Origin deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['HOME']
  },
  {
    id: '12805',
    major: false,
    name: 'bOnline',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/bonline.png',
    synopsis:
      'bOnline offers low-cost business broadband and calls packages for a variety of contract lengths.\r\n\r\n**Compare bOnline deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12809',
    major: false,
    name: 'Woav',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/woav.png',
    synopsis:
      'Woav specialises in business broadband and phone packages that are tailored for the needs of small to medium-sized enterprises.\r\n\r\n**Compare Woav deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12812',
    major: false,
    name: 'NOW TV',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/now-tv.png',
    synopsis:
      "Now TV offers flexible TV, broadband and home phone bundles, with the best of Sky's Sports, Movies and Entertainment channels. \r\n\r\n**Compare Now TV deals**",
    services: ['TV'],
    connectionTypes: ['HOME']
  },
  {
    id: '12816',
    major: false,
    name: 'Toople',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/toople.png',
    synopsis:
      'Toople offers affordable call and broadband packages, including fibre, for small to medium-sized businesses.\r\n\r\n**Compare Toople deals**',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: []
  },
  {
    id: '12819',
    major: false,
    name: 'Amazon',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/amazon.png',
    synopsis:
      'Access over 9,000 films and over 1,000 box sets, including first-run series from overseas. Free one-day shipping from Amazon included in Amazon Prime membership.\r\n\r\n**Compare Amazon Prime deals**',
    services: ['TV'],
    connectionTypes: []
  },
  {
    id: '12823',
    major: false,
    name: 'TVPlayer',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/tvplayer.png',
    synopsis:
      'TVPlayer lets you stream live Freeview channels for free, or you can get a subscription to watch 98 channels, including Discovery, Eurosport and other pay TV.\r\n\r\n**Compare TVPlayer deals**',
    services: ['TV'],
    connectionTypes: []
  },
  {
    id: '12824',
    major: false,
    name: 'EE MBB',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/ee-mbb.png',
    synopsis:
      'EE offers a selection of broadband, calls and TV packages at favourable rates. 4G mobile MiFis also available.\r\n\r\n**Compare EE broadband deals**',
    services: [],
    connectionTypes: ['MOBILE']
  },
  {
    id: '12827',
    major: false,
    name: 'NOW Broadband',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/now-broadband.png',
    synopsis:
      'Now Broadband offers flexible TV, broadband and home phone bundles, with the option to add Entertainment channels. \r\n\r\n**Compare Now TV deals**',
    services: ['BROADBAND'],
    connectionTypes: ['HOME']
  },
  {
    id: '12828',
    major: false,
    name: 'Onestream',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/onestream.png',
    synopsis:
      'Onestream offers Unlimited Broadband and great value call plans, they also specialise in cost-effective Broadband and Fibre deals.\r\n\r\n**Compare Onestream deals**',
    services: ['BROADBAND'],
    connectionTypes: ['HOME']
  },
  {
    id: '12829',
    major: false,
    name: 'Hyperoptic Business',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/hyperoptic-business.png',
    synopsis: '',
    services: [],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12831',
    major: false,
    name: 'Vodafone Business',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/vodafone-business.png',
    synopsis:
      'Vodafone Business offers great value Business Broadband, they also specialise in cost-effective Broadband and Fibre deals.\r\n\r\n**Compare Vodafone Business deals**',
    services: [],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12832',
    major: false,
    name: 'Onebill',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/onebill.png',
    synopsis:
      'Onebill offers Unlimited Business Broadband and great value call plans, they also specialise in cost-effective Broadband and Fibre deals.\r\n\r\n**Compare Onebill deals**',
    services: [],
    connectionTypes: ['BUSINESS']
  },
  {
    id: '12833',
    major: false,
    name: 'Shell Energy Broadband',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/shell-energy-broadband.png',
    synopsis:
      'Energy company Shell now offers ADSL and fibre broadband, with speeds of up to 76Mbps and unlimited downloads. \r\n\r\n**Compare Shell Broadband Energy deals**',
    services: ['BROADBAND'],
    connectionTypes: ['MOBILE']
  },
  {
    id: '12834',
    major: false,
    name: 'Zen Internet',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/zen-internet.png',
    synopsis: '',
    services: [],
    connectionTypes: ['HOME']
  },
  {
    id: '12835',
    major: false,
    name: 'Community Fibre',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/community-fibre.png',
    synopsis:
      "Community Fibre offers London's fastest 100% full fibre broadband. We are bringing faster, more affordable broadband to the communities we serve in London.\r\n\r\n**Compare Community Fibre deals**",
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['HOME']
  },
  {
    id: '12836',
    major: false,
    name: 'Cuckoo',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/cuckoo.png',
    synopsis:
      'Simple broadband, for good. Super-fast fibre broadband, for one fair price, on a one-month rolling contract. And 1% of each bill is used to get the internet to those who need it most.\r\n\r\n**Compare Cuckoo deals**',
    services: ['BROADBAND'],
    connectionTypes: ['HOME']
  },
  {
    id: '12837',
    major: false,
    name: 'KCOM',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/kcom.png',
    synopsis:
      'KCOM is a full fibre broadband provider, delivering super-fast speeds to homes and businesses throughout Yorkshire and Lincolnshire. It delivers a super reliable, future-proof connection, direct to your home. Never before have we needed real broadband more.\r\n\r\n**Compare KCOM deals**',
    services: ['BROADBAND'],
    connectionTypes: ['HOME']
  },
  {
    id: '12838',
    major: false,
    name: 'Sky Business',
    logo: 'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/providers/sky-connect.png',
    synopsis: '',
    services: ['BROADBAND', 'TELEPHONE'],
    connectionTypes: ['BUSINESS']
  }
]

export const BROADBAND_PROVIDER_ORDER = [
  {
    name: 'Virgin Media',
    slug: 'virgin_media'
  },
  {
    name: 'BT',
    slug: 'bt'
  },
  {
    name: 'TalkTalk',
    slug: 'talktalk'
  },
  {
    name: 'Sky',
    slug: 'sky'
  },
  {
    name: 'Plusnet',
    slug: 'plusnet'
  },
  {
    name: 'Vodafone',
    slug: 'vodafone'
  },
  {
    name: 'NOW Broadband',
    slug: 'now_broadband'
  },
  {
    name: 'SSE',
    slug: 'sse'
  },
  {
    name: 'John Lewis Broadband',
    slug: 'john_lewis_broadband'
  },
  {
    name: 'Shell Energy Broadband',
    slug: 'shell_energy_broadband'
  },
  {
    name: 'XLN Telecom',
    slug: 'xln_telecom'
  },
  {
    name: 'Onestream',
    slug: 'onestream'
  },
  {
    name: 'Cuckoo',
    slug: 'cuckoo'
  },
  {
    name: 'KCOM',
    slug: 'kcom'
  },
  {
    name: 'Gigaclear',
    slug: 'gigaclear'
  },
  {
    name: 'Hyperoptic',
    slug: 'hyperoptic'
  },
  {
    name: 'Community Fibre',
    slug: 'community-fibre'
  }
]

export const TV_PROVIDER_ORDER = [
  {
    name: 'NOW TV',
    slug: 'now'
  },
  {
    name: 'BT',
    slug: 'bt'
  },
  {
    name: 'Amazon',
    slug: 'amazon'
  },
  {
    name: 'TalkTalk',
    slug: 'talktalk'
  },
  {
    name: 'Sky',
    slug: 'sky'
  },
  {
    name: 'EE',
    slug: 'ee'
  },
  {
    name: 'Virgin Media',
    slug: 'virgin_media'
  }
]
